"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.forceUpdate = forceUpdate;
function forceUpdate() {
  return function (getState, dispatch) {
    dispatch(null, true);
  };
}